export default __webpack_public_path__ + "static/media/text.a318216a.svg";